export const GET_OFFICE_CLOSEST = '/umbraco/api/offices/closest';
export const POST_FORM_SUBMIT = '/api/form-submit';
export const OUR_PEOPLE = '/umbraco/api/ourpeople/search';
export const ARTICLE_LIST = '/umbraco/api/mediacentreapi/search';
export const SEARCH_RESULTS_LIST = '/umbraco/api/searchapi/search';
